import { HashRouter as Router } from 'react-router'
import AppRoutes from './routes/AppRoutes'
import { SidebarProvider } from './contexts/SidebarContext'
import SnackbarProvider from './contexts/SnackbarProvider'
import { FullScreenProvider } from './contexts/FullScreenContext'

import { Provider } from 'react-redux'
import store from './store'

function App() {
  return (
    <Provider store={store}>
      <Router>
        <SnackbarProvider>
          <SidebarProvider>
            <FullScreenProvider>
              <AppRoutes />
            </FullScreenProvider>
          </SidebarProvider>
        </SnackbarProvider>
      </Router>
    </Provider>
  )
}

export default App
